/** código usado para fazer o loading de itens em uma tab via ajax quando ela é exibida. */
function execAjax(page,{href, replaceElement, method, blockUI, blockElement, responseElement, serializedForm,callback}) {
    $.ajax({
        url: href,
        type: method,
        data: serializedForm + '&page='+page,
        beforeSend: () => {
            if(blockUI && blockElement){
                $(blockElement).block()
            }
        },
        success: res => {
            if(replaceElement){
                $(replaceElement).html(res[responseElement])
            }
            if(callback){
                let callbackChain = callback.split('.')
                if(callbackChain.length == 2){
                    window[callbackChain.shift()][callbackChain.shift()]()
                }else{
                    window[callbackChain.shift()]()
                }
            }
        },
        complete: () => {
            if(blockUI && blockElement){
                $(blockElement).unblock()
            }

        }
    })
}

function exec(element,page){
    if (!page) {
        if ($(element).data('loaded')) {
            return;
        } else {
            $(element).data('loaded', 1)
        }
    }

    if (!page) {
        page = 1;
    }

    var $ref = $(element),
        href = $ref.data('fetch'),
        replaceElement = $ref.data('replace-element'),
        method = $ref.data('method') || 'GET',
        blockUI = $ref.data('block') || true,
        blockElement = $ref.data('block-element') || true,
        responseElement = $ref.data('response-element') || 'html',
        serializedForm = {},
        filterForm = $ref.data('filter-form'),
        callback =  $ref.data('callback')
    if(filterForm){
        serializedForm = $(filterForm).serialize()
    }
    if( href ) {
        execAjax(page,{href, replaceElement, method, blockUI, blockElement, responseElement, serializedForm,callback})
    }
}

function init( contexto = document ){
    $(contexto).on('shown.bs.tab', event => {
        exec(event.target)
    });
}

module.exports = {
    init,exec
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/tabsAjax.js